import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

export interface AutocompleteOption {
  [key: string]: any;
}

@Component({
  selector: 'app-realdesk-autocomplete',
  templateUrl: './realdesk-autocomplete.component.html',
  styleUrls: ['./realdesk-autocomplete.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule
  ]
})
export class RealdeskAutocompleteComponent implements OnInit, OnChanges {
  @Input() isLoading: boolean = false;
  @Input() filteredOptions: Observable<AutocompleteOption[]> = of([]);
  @Input() control: FormControl = new FormControl();
  @Input() placeholder: string = '';
  @Input() tooltip: string = '';
  @Input() displayProperty: string = 'nome';
  @Input() initialValue?: AutocompleteOption;
  @Output() optionSelected = new EventEmitter<AutocompleteOption>();

  ngOnInit() {
    if (this.initialValue) {
      this.control.setValue(this.initialValue);
    }

    // Subscribe to value changes to update display
    this.control.valueChanges.subscribe(value => {
      if (value && typeof value === 'object') {
        this.control.setValue(value, { emitEvent: false });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['initialValue'] && changes['initialValue'].currentValue) {
      this.control.setValue(changes['initialValue'].currentValue);
    }
  }

  displayFn = (option: AutocompleteOption): string => {
    if (!option) return '';
    if (typeof option === 'string') return option;
    const value = option[this.displayProperty];
    return value ? value.toString() : '';
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    const selectedValue = event.option.value;
    this.control.setValue(selectedValue);
    this.optionSelected.emit(selectedValue);
  }
} 